export default __webpack_public_path__ + "static/media/polyester.53d1d21d.jpg";